import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function ArticleSuperbuyVsYoybuy() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <main className="bg-background-50">
      <article>
        <header className="w-full px-6 md:px-10 pt-24 pb-12 md:pt-32 md:pb-16 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <Link to="/" className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-accent-500 transition-colors mb-6">
              <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
              <span>На главную</span>
            </Link>
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">Сравнение</span>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight">
              Superbuy против YOYBUY Spreadsheet: полный разбор
            </h1>
            <p className="mt-5 text-base md:text-lg text-foreground-500 leading-relaxed">
              Сравниваем гиганта Superbuy с инновационной системой таблиц YOYBUY. Где выгоднее заказывать товары из Китая в 2026 году?
            </p>
            <div className="mt-6 flex items-center gap-4 text-xs text-foreground-400">
              <span>Обновлено: Июль 2026</span>
              <span>·</span>
              <span>Время чтения: 6 минут</span>
            </div>
          </div>
        </header>

        <div className="w-full px-6 md:px-10 py-12 md:py-16">
          <div className="max-w-3xl mx-auto">

            <img
              src="https://readdy.ai/api/search-image?query=Balance%20scale%20with%20products%20on%20each%20side%20on%20minimalist%20wooden%20desk%2C%20justice%20and%20fair%20comparison%20concept%2C%20soft%20natural%20window%20light%20from%20left%2C%20Scandinavian%20workspace%20setting%2C%20clean%20fair%20comparison%20aesthetic%2C%20editorial%20product%20review%20style%2C%20warm%20neutral%20tones%2C%20professional%20analysis%20atmosphere&width=1200&height=600&seq=yoybuy-art-superbuy-hero&orientation=landscape"
              alt="Superbuy vs YOYBUY сравнение"
              className="w-full rounded-3xl mb-10 object-cover"
            />

            <section className="mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">Superbuy: гигант с историей</h2>
              <p className="text-base text-foreground-600 leading-relaxed mb-4">
                Superbuy — один из старейших и крупнейших агентов для заказа товаров из Китая. Компания работает с 2012 года и обслужила миллионы заказов. У них мощная логистическая инфраструктура, собственные склады и отработанные процессы. Однако масштаб имеет и обратную сторону: комиссии Superbuy одни из самых высоких на рынке, а каждый дополнительный сервис стоит денег.
              </p>
              <p className="text-base text-foreground-600 leading-relaxed">
                В отличие от Superbuy, <strong>YOYBUY Spreadsheet</strong> не является агентом — это система прямого доступа к данным о товарах через <Link to="/" className="text-accent-500 hover:underline">YOYBUY.PRO</Link>. Вы не платите комиссию агенту за каждый заказ, а получаете прозрачную таблицу с актуальными ценами напрямую от поставщиков.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">Сравнение ключевых параметров</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="p-5 bg-background-100 rounded-2xl">
                  <h4 className="text-sm font-semibold text-foreground-500 uppercase tracking-wider mb-3">Superbuy</h4>
                  <ul className="space-y-2 text-sm text-foreground-700">
                    <li className="flex items-start gap-2"><i className="ri-close-circle-line text-red-400 mt-0.5 w-4 h-4 flex items-center justify-center"></i> Комиссия 8-12% от заказа</li>
                    <li className="flex items-start gap-2"><i className="ri-close-circle-line text-red-400 mt-0.5 w-4 h-4 flex items-center justify-center"></i> Доплата за фото товара</li>
                    <li className="flex items-start gap-2"><i className="ri-check-line text-green-500 mt-0.5 w-4 h-4 flex items-center justify-center"></i> Развитая логистика</li>
                    <li className="flex items-start gap-2"><i className="ri-check-line text-green-500 mt-0.5 w-4 h-4 flex items-center justify-center"></i> Мобильное приложение</li>
                  </ul>
                </div>
                <div className="p-5 bg-accent-50 rounded-2xl">
                  <h4 className="text-sm font-semibold text-accent-700 uppercase tracking-wider mb-3">YOYBUY Spreadsheet</h4>
                  <ul className="space-y-2 text-sm text-foreground-700">
                    <li className="flex items-start gap-2"><i className="ri-check-line text-accent-500 mt-0.5 w-4 h-4 flex items-center justify-center"></i> Без комиссии агента</li>
                    <li className="flex items-start gap-2"><i className="ri-check-line text-accent-500 mt-0.5 w-4 h-4 flex items-center justify-center"></i> Прямые цены поставщиков</li>
                    <li className="flex items-start gap-2"><i className="ri-check-line text-accent-500 mt-0.5 w-4 h-4 flex items-center justify-center"></i> 14 категорий товаров</li>
                    <li className="flex items-start gap-2"><i className="ri-check-line text-accent-500 mt-0.5 w-4 h-4 flex items-center justify-center"></i> Ежедневное обновление</li>
                  </ul>
                </div>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">Для кого какой вариант?</h2>
              <p className="text-base text-foreground-600 leading-relaxed mb-4">
                Superbuy подойдёт тем, кто заказывает товары из Китая впервые и хочет, чтобы все этапы — от покупки до доставки — выполнял агент. Вы платите больше, но получаете сервис «под ключ».
              </p>
              <p className="text-base text-foreground-600 leading-relaxed mb-4">
                <strong>YOYBUY Spreadsheet</strong> создан для тех, кто заказывает регулярно и хочет контролировать процесс самостоятельно. Система таблиц даёт вам данные, а решения принимаете вы. Экономия на комиссиях при регулярных закупках может составлять сотни долларов в месяц.
              </p>
              <div className="p-5 bg-accent-50 rounded-2xl">
                <p className="text-sm text-accent-800 leading-relaxed">
                  <strong>Вывод:</strong> для регулярных закупок из Китая YOYBUY Spreadsheet значительно выгоднее Superbuy. Для разовых заказов новичкам Superbuy может быть удобнее за счёт полного сопровождения.
                </p>
              </div>
            </section>

            <div className="mt-14 p-8 bg-primary-500 rounded-3xl text-center">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">Сравните сами</h2>
              <p className="text-base text-background-50/80 mb-6 max-w-md mx-auto">
                Попробуйте YOYBUY Spreadsheet и убедитесь, что прозрачные цены — это реальность.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="px-7 py-3.5 rounded-full bg-background-50 text-primary-600 text-sm font-semibold hover:bg-accent-100 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 justify-center">
                  <span>YOYBUY SHEET</span>
                  <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
                </a>
                <Link to="/" className="px-7 py-3.5 rounded-full border-2 border-background-50/40 text-background-50 text-sm font-semibold hover:border-background-50 hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 justify-center">
                  <span>На главную</span>
                  <i className="ri-home-4-line w-4 h-4 flex items-center justify-center"></i>
                </Link>
              </div>
            </div>

            <div className="mt-10 pt-10 border-t border-background-200">
              <Link to="/" className="inline-flex items-center gap-2 text-sm text-foreground-400 hover:text-accent-500 transition-colors">
                <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
                <span>← Вернуться на главную страницу YOYBUY.PRO</span>
              </Link>
            </div>
          </div>
        </div>
      </article>

      <footer className="w-full px-6 md:px-10 py-10 bg-foreground-950">
        <div className="max-w-3xl mx-auto text-center">
          <Link to="/" className="text-xl font-heading font-bold text-background-50">YOYBUY<span className="text-accent-500">.PRO</span></Link>
          <p className="mt-3 text-xs text-background-50/30">© 2026 YOYBUY.PRO. Все права защищены.</p>
        </div>
      </footer>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org", "@type": "Article",
          "headline": "Superbuy против YOYBUY Spreadsheet: полный разбор",
          "description": "Сравниваем Superbuy и YOYBUY Spreadsheet: комиссии, удобство таблиц, скорость обработки заказов.",
          "datePublished": "2026-07-05", "dateModified": "2026-07-05",
          "author": {"@type": "Organization", "name": "YOYBUY.PRO"},
          "publisher": {"@type": "Organization", "name": "YOYBUY.PRO"},
          "mainEntityOfPage": {"@type": "WebPage", "@id": `${import.meta.env.VITE_SITE_URL}/article/superbuy-vs-yoybuy`}
        })}
      </script>
    </main>
  );
}